import React from 'react';
import { compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { Link } from 'react-router-dom';
import ModalLink from '../ModalLink';
import { Modal } from 'semantic-ui-react';
import Auth from 'containers/Auth';
import { injectIntl } from 'react-intl';

class PrivateLink extends React.Component {
  state = {
    contentFor: 'login',
    modalOpen: false,
  };

  componentWillReceiveProps() {
    if (this.props.contentFor) {
      this.setState({ contentFor: this.props.contentFor });
    }
  }

  handleOpen = () => this.setState({ modalOpen: true });

  handleClose = () =>
    this.setState({
      modalOpen: false,
      contentFor: this.props.contentFor ? this.props.contentFor : 'login',
    });

  switchModalTo = (contentFor) => {
    this.setState({ contentFor });
  };

  modalHeader = () =>
    ({
      register:
        this.props.intl.locale === 'ar'
          ? 'إنشاء حساب جديد'
          : 'Create New Account',
      forgetpass:
        this.props.intl.locale === 'ar'
          ? 'استعادة كلمة المرور'
          : 'Reset Your Password',
      login:
        this.props.intl.locale === 'ar'
          ? 'تسجيل الدخول لحسابك'
          : 'Login to your Account',
    }[this.state.contentFor]);

  modalContent = () => (
    <Modal.Content>
      <Auth
        switchModalTo={this.switchModalTo}
        redirectTo={this.props.to}
        handleClose={this.handleClose}
        contentFor={this.state.contentFor}
      />
    </Modal.Content>
  );

  render() {
    const {
      intl,
      isLoggedIn,
      contentFor,
      currentUser,
      geo,
      ...remainingProps
    } = this.props;

    return isLoggedIn ? (
      <Link {...remainingProps} />
    ) : (
      <ModalLink
        linkProps={{ ...remainingProps }}
        modalProps={{
          size: 'mini',
          open: this.state.modalOpen,
          onClose: () => this.handleClose(),
          // header: this.modalHeader(),
          content: this.modalContent(),
          closeIcon: true,
        }}
        handleOpen={this.handleOpen}
      />
    );
  }
}

const IS_LOGGED_IN = gql`
  query IsLoggedIn {
    isLoggedIn
  }
`;

export default compose(
  injectIntl,
  graphql(IS_LOGGED_IN, {
    options: { fetchPolicy: 'cache-only' },
    props: ({ data: { isLoggedIn } }) => ({
      isLoggedIn,
    }),
  })
)(PrivateLink);



// WEBPACK FOOTER //
// ./app/components/Link/PrivateLink/index.js